import { Navigate } from 'react-router-dom';
import { ADMIN_DASHBOARD_PATH } from 'router/adminPath';

const AdminPage = () => {
  // Automatically redirect to dashboard
  return <Navigate to={ADMIN_DASHBOARD_PATH} replace />;
};

export default AdminPage;

